import { useBoundStore } from 'src/store/store';

export function useToolbar(): {
  toolbarTitle: string;
  setToolbarTitle: (toolbarTitle: string) => void;
} {
  const { toolbarTitle, setToolbarTitle: setToolbarTitleStore } = useBoundStore(
    (state) => state,
  );

  const setToolbarTitle = (toolbarTitle: string) => {
    setToolbarTitleStore(toolbarTitle);
  };

  return { toolbarTitle, setToolbarTitle };
}
